import { PrimaryButton } from '@liveoptics/react-ui';
import React, { useCallback } from 'react';
import { VerifyOwnerState } from '../../../../enums';
import TextButton from '../../../buttons/TextButton';
import SelectionOption from '../SelectionOption';
import Form from '../form/Form';

const SkipForm = (props: {
  verifyOwnerStateCallback: (state: VerifyOwnerState, value?: unknown) => void;
  onOptionChange: (option: SelectionOption) => void;
  onCancel: () => void;
}) => {
  const handleSaveClick = useCallback(() => {
    props.verifyOwnerStateCallback(VerifyOwnerState.SkipVerifyOwner);
  }, [props]);

  return (
    <Form
      selectionOption={SelectionOption.Skip}
      renderActions={() => (
        <>
          <TextButton onClick={props.onCancel}>Cancel</TextButton>
          <PrimaryButton clickFn={handleSaveClick}>Next</PrimaryButton>
        </>
      )}
      onChange={props.onOptionChange}
    ></Form>
  );
};

export default SkipForm;
